import axios from '../base/axios';
import API_KEY from './key';

const GET_TRENDING = 'flixfrenzy/redux/GET_TRENDING';

// eslint-disable-next-line default-param-last
const trendingReducer = (state = [], action) => {
  switch (action.type) {
    case GET_TRENDING:
      return action.payload;
    default:
      return state;
  }
};

export const getTrending = () => (dispatch) => {
  axios.get(`trending/movie/week?api_key=${API_KEY}&language=en-US`).then((res) => {
    dispatch({
      type: GET_TRENDING,
      payload: res.data,
    });
  });
};

export default trendingReducer;
